import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type GetMembersQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetMembersQueryResult = { __typename?: 'Query' } & {
  currentUserDetails?: GraphQLTypes.Maybe<
    { __typename?: 'AccountMember' } & {
      account: { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'organizationalRole' | 'parentAccountId'>;
    }
  >;
};

export const GetMembersDocument = gql`
  query getMembers {
    currentUserDetails {
      account {
        id
        organizationalRole
        parentAccountId
      }
    }
  }
`;
